import { RouteName } from '@app/router/constants/RouteName';
import router from '@app/router';
import { Site } from '@superbet-group/web.types';
import { getCurrentSite } from '@app/utils/domainHelpers';

export function navigateToWiki(slug: string) {
    const wikiPath = getWikiPath(slug);

    if (wikiPath.startsWith('https')) {
        window.open(wikiPath, '_blank');
    } else {
        router.push(wikiPath);
    }
}

export function getWikiPath(slug: string): string {
    const url = router.resolve({
        name: RouteName.App.Wiki,
        params: {
            pageSlug: slug,
        },
    }).resolved.path;

    const napoleonDomains: Site[] = [
        Site.NapoleonCasino,
        Site.NapoleonDice,
        Site.NapoleonSports,
    ];
    const isNapoleonWiki = napoleonDomains.includes(getCurrentSite(window.location.hostname) as any);

    if (isNapoleonWiki) {
        const host = window.location.host;
        const redirectHost = host
            .replace('napoleonsports', 'napoleongames')
            .replace('napoleoncasino', 'napoleongames')
            .replace('napoleondice', 'napoleongames');

        return `https://${redirectHost}${url}`;
    } else {
        return url.replace('%23', '#');
    }
}
